import type { CompradorPessoaJuridicaSchemaOutput } from '@/features/proposta/schemas/compradores/comprador-pj.schema'
import type { TCreatePessoaJuridicaData } from '@/shared/interfaces/conta.types'

export const toContaDto = (comprador: CompradorPessoaJuridicaSchemaOutput): TCreatePessoaJuridicaData => {
  return {
    cnpj: comprador.dados.cnpj.replaceAll(/\D/g, ''),
    razaoSocial: comprador.dados.razaoSocial,
    email: comprador.dados.email ?? '',
    telefone: {
      numero: comprador.dados.telefone!.numero.replaceAll(/\D/g, ''),
      origem: comprador.dados.telefone!.origem,
      principal: true,
    },
  }
}
